import styled from 'styled-components';

import { hideOverflowText, mediaSize } from '../../../../styles';


export const TrashIconWrap = styled.div`
  display: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.fontSilverLight};
`;

export const ItemContentWrap = styled.div`
  display: flex;
  overflow-x: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
`;

export const ExtensionIcon = styled.div`
  width: 40px;
  height: 40px;
  background-color: ${({ theme }) => theme.colors.fontTangerine};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 10px;
`;

export const ExtensionIconText = styled.span`
  font-weight: 300;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.white};
`;

export const AttachmentMetaWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 10px;
  max-width: 235px;
`;

export const AttachmentNameWrap = styled.a`
  ${hideOverflowText};
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 300;
  color: ${({ theme }) => theme.colors.fontSilverLight};

  &:hover {
    cursor: pointer;
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.fontLightBlack};
  }
`;

export const AttachmentSizeWrap = styled.div`
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.fontSilverLighter};
`;

export const ItemWrap = styled.div`
  display: flex;
  width: ${({ minView }) => minView ? '285px' : '298px'};
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  &:hover {
    ${TrashIconWrap} {
      display: inline;
      margin-right: 10px;
      margin-top: 20px;
    }
  }

  @media (max-width: ${mediaSize.phone}) {
    ${ExtensionIcon} {
      width: 30px;
      height: 30px;
      font-size: 12px;
    }

    ${AttachmentMetaWrap} {
      max-width: calc(100% - 40px);
    }
  }
`;

export const DeleteIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  height: 18px;
  width: 18px;
  box-shadow: 0 2.57143px 9px rgba(0, 0, 0, 0.12);
  position: relative;
  top: 10px;
  left: -9px;
  background-color: ${({ theme }) => theme.colors.white};
`;


export const ItemContentContainer = styled.div`
  display: flex;
  overflow-x: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  height: 43px;
  padding: 6px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.lightGreySilver};
`;

export const FileIcon = styled.div`
  width: 30px;
  height: 30px;
  background-color: ${({ theme }) => theme.colors.fontTangerine};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 6px;
`;

export const FileIconText = styled.span`
  font-size: 10px;
  line-height: 12px;
  color: ${({ theme }) => theme.colors.white};
`;

export const AttachmentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 10px;
  max-width: 235px;
`;

export const AttachmentName = styled.a`
  ${hideOverflowText};
  font-style: normal;
  font-weight: normal;
  font-size: 13.1579px;
  line-height: 16px;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.mainDark};
  margin: auto;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.fontLightBlack};
  }
`;

export const ItemNinViewWrapper = styled.div`
  :first-child {
    margin-left: 10px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/attachments/list/item/styled-components.js